import PropTypes from 'prop-types';
import React from 'react';
import {
  ButtonToolbar,
  ButtonGroup,
  Button,
  MenuItem,
  DropdownButton,
  Modal,
} from 'react-bootstrap';
import diff from 'object-diff';

import { formalDate, fromNow, daysBetween } from '../../../core/date';

import BidDetailTable from './BidDetailTable';
import BidDetailForm from './BidDetailForm';
import moment from 'moment';

function getInitialValues(bid, bid_details) {
  const nights = daysBetween(bid.bidset.event.end, bid.bidset.event.start);
  const bidData = [];
  bid_details.map(c => {
    let data = bidData.find(bd => bd.check_in_date == c.bid_details.check_in_date && bd.check_out_date == c.bid_details.check_out_date && bd.room_type == c.bid_details.room_type)
    if (data) {
      data.no_of_Guest++
    } else {
      let insertObj = {
        room_type: c.bid_details.room_type,
        no_of_Guest: 1,
        check_in_date: c.bid_details.check_in_date,
        check_out_date: c.bid_details.check_out_date,
        rate_per_night: c.rate_per_night
      }
      // If room_type is 4 then it's NoHotel room
      if(insertObj.room_type !== 4){
        bidData.push(insertObj)
      }
    }
  })
    
  const initialValues = {
    hotel: {
      tax_rate: bid.hotel.tax_rate
        ? Number(bid.hotel.tax_rate * 100.0).toFixed(3)
        : bid.hotel.tax_rate,
      currency: bid.hotel.currency,
    },
    commission_rate: bid.commission_rate
      ? Number(bid.commission_rate * 100.0).toFixed(3)
      : bid.commission_rate,
    nights,
    additional_tax: bid.hotel.additional_tax,
    resort_fee: bid.resort_fee,
    bidData
  };
  return initialValues;
}

class BidDetailPricing extends React.Component {
  constructor(props) {
    super(props);
    const bid = props.bid
    const bid_bid_details = props.bidbidsDetails
    let bidData = []
    bid_bid_details.map(c => {
      let data = bidData.find(bd => bd.check_in_date == c.bid_details.check_in_date && bd.check_out_date == c.bid_details.check_out_date && bd.room_type == c.bid_details.room_type)
      if (data) {
        data.no_of_Guest++
      } else {
        let insertObj = {
          room_type: c.bid_details.room_type,
          no_of_Guest: 1,
          check_in_date: c.bid_details.check_in_date,
          check_out_date: c.bid_details.check_out_date,
          rate_per_night: c.rate_per_night
        }
        // If room_type is 4 then it's NoHotel room
        if(insertObj.room_type !== 4){
          bidData.push(insertObj)
        }
        // bidData.push(insertObj)
      }
    })
    const bid_details_input = {
      tax_rate: bid.hotel.tax_rate
        ? Number(bid.hotel.tax_rate * 100.0).toFixed(3)
        : bid.hotel.tax_rate,

      commission_rate: bid.commission_rate
        ? Number(bid.commission_rate * 100.0).toFixed(3)
        : bid.commission_rate,
      bidData: bidData,
      currency: bid.hotel.currency,
      additional_tax: bid.hotel.additional_tax,
      resort_fee: bid.resort_fee
    }

    let sum = 0;
    bid_details_input.bidData.map(c => {
      const a = moment(c.check_out_date);
      const b = moment(c.check_in_date);
      sum += Number(c.no_of_Guest) * a.diff(b, 'days') * Number(c.rate_per_night)
    })

    sum += Number(bid_details_input.tax_rate / 100.0 || 0) * sum;
    bid_details_input.bidData.map(bid => {
      const check_out = moment(bid.check_out_date);
      const check_in = moment(bid.check_in_date);
      sum += Number(bid.no_of_Guest) * check_out.diff(check_in, 'days') * Number(bid_details_input.additional_tax)
      sum += Number(bid.no_of_Guest) * check_out.diff(check_in, 'days') * Number(bid_details_input.resort_fee)
    })
    // sum += Number(bid_details_input.additional_tax);
    bid_details_input.total = parseFloat(sum).toFixed(2);

    const cellEditProp = {
      mode: 'click',
      blurToSave: true,
      afterSaveCell: this.onAfterSaveCell,
    };

    this.state = {
      showModal: false,
      edit: false,
      bid_details_input: bid_details_input,
      cellEditProp: cellEditProp,
      isValidRatePerNight: true,
      showPopUp:false,
      tourData:this.props.tourData,
      bidbidsDetails:[],

    };
    this.handleEdit = this.handleEdit.bind(this);
    this.handleBidSubmit = this.handleBidSubmit.bind(this);
    this.openPopUp = this.openPopUp.bind(this);
    this.OnClose = this.OnClose.bind(this);
    this.changeData = this.changeData.bind(this);
    this.updateBidData = this.updateBidData.bind(this);
    this.onDeleteData = this.onDeleteData.bind(this);
  }
  handleEdit() {
    this.setState({ edit: true });
  }

  openPopUp() {
    this.setState({ showPopUp: true });
  }
  OnClose(){
    this.setState({ showPopUp: false });
  }
  
  handleBidSubmit(values) {
    const initialValues = getInitialValues(this.props.bid, this.props.bidbidsDetails)
    if (initialValues.hotel) {
      initialValues.hotel.tax_rate = Number(this.state.bid_details_input.tax_rate / 100.0).toFixed(6);
      initialValues.hotel.additional_tax = Number(this.state.bid_details_input.additional_tax);
    }
    if (initialValues.commission_rate >= 0) {
      initialValues.commission_rate = Number(this.state.bid_details_input.commission_rate / 100.0).toFixed(3);
    }

    initialValues.resort_fee = Number(this.state.bid_details_input.resort_fee);
    initialValues.currency = this.state.bid_details_input.currency

    if (values.note) {
      initialValues.note = values.note;
    }

    // initialValues.bidder_state = 'RE';
    initialValues.bidder = { id: this.props.user.id };

    initialValues.bid_details_request = this.state.bid_details_input.bidData.map(c => {
      return this.saveBidDetails(c)
    })

    const payload = diff(getInitialValues(this.props.bid, this.props.bidbidsDetails), initialValues);
    // Check is there any invalid bid request with invalid rate_per_night
    const inValidBidDetailsRequest = payload.bid_details_request.filter(x => x.rate_per_night == null || x.rate_per_night == 0 || x.rate_per_night == '');
    
    if(inValidBidDetailsRequest.length > 0){
      this.setState({
        isValidRatePerNight: false
      });
    }else{
      this.setState({
        isValidRatePerNight: true
      });
      delete payload.bidData;

      this.props.editBid(this.props.bid.id, payload);
      this.setState({ edit: false });
      this.afterSaveUpdateDidDetails(this.state.bid_details_input.bidData);
    }
  }
  updateBidData(response){
    const bid_detail = response.bid_detail;
    const bidbidsDetails = this.props.bidbidsDetails;
    const newData = [];
    bidbidsDetails.map((val)=>{
      bid_detail.map((bid)=>{
        if(val.bid_details.id==bid.id){
          val.bid_details.check_in_date = bid.check_in_date;
          val.bid_details.check_out_date = bid.check_out_date;
          val.bid_details.suite = bid.suite;
          val.bid_details.king = bid.king;
          val.bid_details.double = bid.double;
          val.bid_details.room_type = bid.room_type;
        }
      }); 
      newData.push(val)
    });
    this.setState({bidbidsDetails:newData})


    
  }
  changeData(response){
    const tour = response.tour;
    const bidbidsDetails = response.BidBidDetails;
    this.setState({
      tourData:tour,
      bidbidsDetails:bidbidsDetails,
    })
  }
  onDeleteData(id){
    const bidsDetails = this.state.bidbidsDetails;
    const data = bidsDetails.length>0?bidsDetails:this.props.bidbidsDetails;
    const newBidBidsDetails = []
    data.map((val)=>{
      if (val.bid_details.travelprofile_id!=id){
        newBidBidsDetails.push(val)
      }
    });
    this.setState({bidbidsDetails:newBidBidsDetails})
  }

  afterSaveUpdateDidDetails = (bidData) => {
    // const bidData = this.state.bid_details_input.bidData;
      this.props.bidbidsDetails.map(c => {
      let data = bidData.find(bd => bd.check_in_date == c.bid_details.check_in_date && bd.check_out_date == c.bid_details.check_out_date && bd.room_type == c.bid_details.room_type)
      if (data) {
        c.rate_per_night = data.rate_per_night;
      }
    })
  }

  onCurrencyChange = (e) => {
    if (e) {
      const bid_details_input = { ...this.state.bid_details_input }
      bid_details_input.currency = e.value

      this.setState({
        bid_details_input
      })
    }
  }

  onRateChange = (e, type) => {


    var bid_details_input = { ...this.state.bid_details_input }
    bid_details_input[type] = e.target.value


    let sum = 0;
    bid_details_input.bidData.map(c => {
      const a = moment(c.check_out_date);
      const b = moment(c.check_in_date);
      sum += Number(c.no_of_Guest) * a.diff(b, 'days') * Number(c.rate_per_night)
    })

    sum += Number(bid_details_input.tax_rate / 100.0 || 0) * sum;
    sum += this.handleAddAdditionalTax(bid_details_input);

    bid_details_input.total = parseFloat(sum).toFixed(2);

    this.setState({
      bid_details_input
    })
  }

  onAfterSaveCell = (row, cellName, cellValue) => {
    var bid_details_input = { ...this.state.bid_details_input }
    let sum = 0;
    bid_details_input.bidData.map(c => {
      const a = moment(c.check_out_date);
      const b = moment(c.check_in_date);
      sum += Number(c.no_of_Guest) * a.diff(b, 'days') * Number(c.rate_per_night)
    })
    sum += Number(bid_details_input.tax_rate / 100.0 || 0) * sum;
    sum += this.handleAddAdditionalTax(bid_details_input);
    bid_details_input.total = parseFloat(sum).toFixed(2);
    this.setState({
      bid_details_input
    })
  }

  handleAddAdditionalTax(bidDetail){
    let sum = 0;
    bidDetail.bidData.map(bid => {
      const check_out = moment(bid.check_out_date);
      const check_in = moment(bid.check_in_date);
      if(bid.rate_per_night){
        sum += Number(bid.no_of_Guest) * check_out.diff(check_in, 'days') * Number(bidDetail.additional_tax)
        sum += Number(bid.no_of_Guest) * check_out.diff(check_in, 'days') * Number(bidDetail.resort_fee)
     }
    })
    return sum;
  }

  saveBidDetails = (data) => {
    const bid_details_ids = this.props.bidbidsDetails.filter(o => o.bid_details.check_in_date == data.check_in_date &&
      o.bid_details.check_out_date == data.check_out_date &&
      o.bid_details.room_type == data.room_type).map(c => {
        return c.id;
      });
    const obj = {
      rate_per_night: data.rate_per_night,
      ids: bid_details_ids,
      bid_id: this.props.bid.id
    }
    return obj
  }

  render() {
    const tour = this.state.tourData;
    const bidsDetail = this.state.bidbidsDetails;
    const tourData = tour?tour:this.props.tourData;
    const bidbidsDetails = bidsDetail.length!=0?bidsDetail:this.props.bidbidsDetails;
    const { bid } = this.props;
    const canEdit = this.props.bid.buyer_state === 'PB' && !this.props.isTourManager;
    const bidData = [];
    let isValidRatePerNight = this.state.isValidRatePerNight;
    let bid_details = bidbidsDetails.filter(c => c.bid_details.room_type);
    bid_details.map(c => {
      let data = bidData.find(bd => bd.check_in_date == c.bid_details.check_in_date && bd.check_out_date == c.bid_details.check_out_date && bd.room_type == c.bid_details.room_type)
      if (data) {
        data.no_of_Guest++
      } else {
        let insertObj = {
          room_type: c.bid_details.room_type,
          no_of_Guest: 1,
          check_in_date: c.bid_details.check_in_date,
          check_out_date: c.bid_details.check_out_date,
          rate_per_night: c.rate_per_night
        }
        // If room_type is 4 then it's NoHotel room
        if(insertObj.room_type !== 4){
          bidData.push(insertObj)
        }
      }
    })
    if (this.state.bid_details_input.bidData.length == 0 && bidData.length == bid_details.length) {
      this.state.bid_details_input.bidData = bidData
    }
    // Check is there any invalid bid request with invalid rate_per_night
    const inValidBidDetailsRequest = this.state.bid_details_input.bidData.filter(x => x.rate_per_night == null || x.rate_per_night == 0 || x.rate_per_night == '');
    if(inValidBidDetailsRequest.length > 0){
      isValidRatePerNight = false ;
    }else{
      isValidRatePerNight = true ;
    }

    if (this.state.edit) {
      return (
        <BidDetailForm
          initialValues={getInitialValues(this.props.bid, bidbidsDetails)}
          bid={this.props.bid}
          editBid={this.props.editBid}
          bid_details_input={this.state.bid_details_input}
          cellEditProp={this.state.cellEditProp}
          isValidRatePerNight={this.state.isValidRatePerNight}
          onRateChange={this.onRateChange}
          onCurrencyChange={this.onCurrencyChange}
          onSubmit={this.handleBidSubmit}
        />
      );
    }
    return (
      <BidDetailTable
        bid={this.props.bid}
        canEdit={canEdit}
        handleEdit={this.handleEdit}
        isTourManager={this.props.isTourManager}
        tourData={tourData}
        editMember={this.props.editMember}
        bidbidsDetails={bidbidsDetails}
        isLoading={this.props.isLoading}
        openPopUp={this.openPopUp}
        OnClose={this.OnClose}
        editGroup={this.props.editGroup}
        showPopUp={this.state.showPopUp}
        ChangeBidDetail={this.props.ChangeBidDetail}
        changeBidDateDetail={this.props.changeBidDateDetail}
        editGroupEventOnManageBid={this.props.editGroupEventOnManageBid}
        requestBidDetails={this.props.requestBidDetails}
        dispatchRemoveMemberFromManageBid={this.props.dispatchRemoveMemberFromManageBid}
        changeDateRoomType={this.props.changeDateRoomType}
        addParticipantManageBid={this.props.addParticipantManageBid}
        updateBidData={this.updateBidData}
        changeData={this.changeData}
        onDeleteData={this.onDeleteData}
      />
    );
  }
}

BidDetailPricing.propTypes = {
  bid: PropTypes.object.isRequired,
  isTourManager: PropTypes.bool.isRequired,
  editBid: PropTypes.func.isRequired,
  tourData: PropTypes.object,
  editMember: PropTypes.func,
  dispatchRemoveMemberFromManageBid: PropTypes.func,
  user: PropTypes.object.isRequired,
  changeDateRoomType: PropTypes.func,
  addParticipantManageBid: PropTypes.func,
};
export default BidDetailPricing;



// WEBPACK FOOTER //
// src/routes/tours/components/BidDetailPricing.js